import React, { useState } from "react";

const fmt = (p, dp = 2) => (p == null || Number.isNaN(p) ? "—" : p.toLocaleString(undefined, { minimumFractionDigits: dp, maximumFractionDigits: dp }));

// Close (or partially close) a position. Mirrors TradingView's close dialog.
export default function ClosePositionModal({ position, onClose, onConfirm }) {
  const [partial, setPartial] = useState(false);
  const [qtyStr, setQtyStr] = useState("");
  const [mode, setMode] = useState("qty"); // qty | pct
  if (!position) return null;

  const maxQty = position.qty;
  let qty = maxQty;
  if (partial) {
    const v = parseFloat(qtyStr) || 0;
    qty = mode === "pct" ? (maxQty * Math.min(100, v)) / 100 : Math.min(v, maxQty);
  }

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/50" onClick={onClose}>
      <div className="bg-zinc-900 border border-zinc-700 rounded-lg w-[340px] p-4 text-xs text-zinc-200" onClick={(e) => e.stopPropagation()}>
        <div className="font-semibold text-zinc-100 mb-3">
          OKX:{position.symbol}USDT.P · {position.side === "long" ? "Long" : "Short"} {fmt(maxQty, 4)} @ {fmt(position.avgPrice)}
        </div>

        <label className="flex items-center gap-2 mb-2">
          <input type="checkbox" checked={partial} onChange={(e) => setPartial(e.target.checked)} /> Partial close
        </label>

        {partial && (
          <div className="flex items-center gap-2 mb-3">
            <input value={qtyStr} onChange={(e) => setQtyStr(e.target.value)} placeholder={mode === "pct" ? "%" : "qty"}
              className="flex-1 bg-zinc-800 rounded px-2 py-1.5 outline-none font-mono" />
            <button onClick={() => setMode((m) => (m === "qty" ? "pct" : "qty"))}
              className="px-2 py-1.5 bg-zinc-800 rounded text-[10px]">{mode === "qty" ? "qty" : "%"}</button>
            <span className="text-[10px] text-zinc-500 w-20 text-right">{fmt(qty, 4)} units</span>
          </div>
        )}

        <div className="flex justify-end gap-2 mt-3">
          <button onClick={onClose} className="px-3 py-1.5 rounded bg-zinc-800 hover:bg-zinc-700">Cancel</button>
          <button onClick={() => onConfirm(partial ? qty : undefined)}
            className="px-3 py-1.5 rounded bg-rose-600 hover:bg-rose-500 text-white">Close position</button>
        </div>
      </div>
    </div>
  );
}
